var _rect, _circle, _path, _g, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyDataDrawer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 181,
    viewBox: "0 0 181 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1671_1934)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "translate(0.5 0.754242)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 91.6107,
    cy: 90.427,
    r: 85.0909,
    fill: "#D6DAE4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1671_1934",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -25,
    y: -42,
    width: 293,
    height: 253
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.7 120.863C166.755 128.718 162.173 138.536 150.718 149.663L130.755 210.536L6.06368 198.1L-24.0454 183.372L-13.9 -20.5185L100.645 -41.1367L267.227 83.8815C265.155 119.554 170.803 117.922 169.7 120.863Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1671_1934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.8746,
    y: 34.818,
    width: 135.8,
    height: 101.009,
    rx: 2.11818,
    transform: "rotate(6.46141 41.8746 34.818)",
    fill: "white",
    stroke: "#22283C"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.71119,
    y: 57.0726,
    width: 135.8,
    height: 96.5273,
    rx: 2.11818,
    transform: "rotate(-12 3.71119 57.0726)",
    fill: "white",
    stroke: "#22283C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8515 115.669L38.8423 104.756L54.236 104.488L66.3262 94.6241L80.9892 94.8821L90.5459 76.9747L107.582 81.3876L123.592 73.2931L132.707 62.3663",
    stroke: "#22283C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7805,
    y: 128.614,
    width: 22.6981,
    height: 1.30909,
    transform: "rotate(-12 27.7805 128.614)",
    fill: "#ECEEF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6167,
    y: 122.06,
    width: 17.0235,
    height: 1.30909,
    transform: "rotate(-12 58.6167 122.06)",
    fill: "#ECEEF5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4355,
    y: 117.209,
    width: 6.93552,
    height: 1.30909,
    transform: "rotate(-12 81.4355 117.209)",
    fill: "#ECEEF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.205,
    y: 109.606,
    width: 4.41351,
    height: 1.30909,
    transform: "rotate(-12 117.205 109.606)",
    fill: "#ECEEF5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 125.223,
    y: 107.902,
    width: 17.654,
    height: 1.30909,
    transform: "rotate(-12 125.223 107.902)",
    fill: "#ECEEF5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8691,
    y: 133.736,
    width: 22.6981,
    height: 1.30909,
    transform: "rotate(-12 28.8691 133.736)",
    fill: "#ECEEF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.7056,
    y: 127.182,
    width: 17.0235,
    height: 1.30909,
    transform: "rotate(-12 59.7056 127.182)",
    fill: "#ECEEF5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5242,
    y: 122.331,
    width: 6.93552,
    height: 1.30909,
    transform: "rotate(-12 82.5242 122.331)",
    fill: "#ECEEF5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 118.294,
    y: 114.728,
    width: 4.41351,
    height: 1.30909,
    transform: "rotate(-12 118.294 114.728)",
    fill: "#ECEEF5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 126.312,
    y: 113.024,
    width: 17.654,
    height: 1.30909,
    transform: "rotate(-12 126.312 113.024)",
    fill: "#ECEEF5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8218,
    y: 138.218,
    width: 22.6981,
    height: 1.30909,
    transform: "rotate(-12 29.8218 138.218)",
    fill: "#ECEEF5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60.658,
    y: 131.663,
    width: 17.0235,
    height: 1.30909,
    transform: "rotate(-12 60.658 131.663)",
    fill: "#ECEEF5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 83.4768,
    y: 126.813,
    width: 6.93552,
    height: 1.30909,
    transform: "rotate(-12 83.4768 126.813)",
    fill: "#ECEEF5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 119.247,
    y: 119.21,
    width: 4.41351,
    height: 1.30909,
    transform: "rotate(-12 119.247 119.21)",
    fill: "#ECEEF5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 127.264,
    y: 117.506,
    width: 17.654,
    height: 1.30909,
    transform: "rotate(-12 127.264 117.506)",
    fill: "#ECEEF5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9233,
    y: 68.1266,
    width: 14.7241,
    height: 4.80436,
    transform: "rotate(-12 14.9233 68.1266)",
    fill: "#ECEEF5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2092,
    y: 74.8552,
    width: 24.5646,
    height: 4.80436,
    transform: "rotate(-12 16.2092 74.8552)",
    fill: "#ECEEF5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 123.755,
    y: 44.9936,
    width: 6.00984,
    height: 5.08416,
    transform: "rotate(-12 123.755 44.9936)",
    fill: "#ECEEF5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 113.736,
    y: 47.1674,
    width: 6.00984,
    height: 5.08416,
    transform: "rotate(-12 113.736 47.1674)",
    fill: "#ECEEF5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 103.918,
    y: 49.7856,
    width: 6.00984,
    height: 5.08416,
    transform: "rotate(-12 103.918 49.7856)",
    fill: "#ECEEF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1671_1934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(0.5 0.754242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDataDrawer);
export default __webpack_public_path__ + "static/media/empty-data-drawer.a18a4f6a2189c5e9241deeb1bb1cb42c.svg";
export { ForwardRef as ReactComponent };